<template>
  <div class="modal" @click="closeFreehandModal()">
    <div class="modal-content" @click.stop=";">
      <div class="title no-select">{{attachmentId === 'new' ? 'New' : ''}} Freehand</div>
      <div class="color-picker-wrapper">
        <label class="color-text no-select">Pen Colour</label>
        <ColorPicker
          class="color-picker"
          :color="drawColor"
          v-model="drawColor"
        />
      </div>
      <div id="freehandContainer">
        <canvas id="freehandCanvas" ref="freehandCanvas" width="300" height="300" class="freehand-canvas"></canvas>
      </div>
      <button v-on:click.stop="closeFreehandModal()" class="button is-pulled-left">Cancel</button>

      <div class="is-pulled-right">
        <button v-on:click.stop="clearCanvas()" class="button">Clear</button> 
        <button v-on:click.stop="deleteMode = true" v-if="attachmentId !== 'new'" class="button">Delete</button> 
        <button v-on:click.stop="upsertFreehand()" class="button is-primary">{{attachmentId === 'new' ? 'Save' : 'Update'}}</button>
      </div>
    </div>
    <!-- Delete Modal -->
    <div v-if="deleteMode" class="modal no-select">
      <div class="modal-content">
          <h3 class="has-text-left">Confirm deletion</h3>
          <p class="has-text-left">Are you sure you want to delete this annotation? It will be deleted permanently.</p>
        <div class="modal-buttons is-pulled-right">
          <button class="button is-primary no-button" v-on:click.stop="deleteMode = false">No</button>
          <button  v-on:click.stop="deleteFreehand()" class="button yes-button">Yes</button> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import ColorPicker from "./ColorPicker";
import {encode, decode} from "messagepack"; //https://www.npmjs.com/package/messagepack
import utils from '@/utils/utils.js';
import storeHelpers from '@/utils/storeHelpers.js';
import annotationUtils from '@/utils/annotationUtils.js';

export default {
  name: 'Freehand',
  components: {
    ColorPicker
  },
  props: {
    contextMenuOptions: {
      type: Object,
      required: true
    },
    attachmentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      title: "New freehand",
      drawColor: "#FF0000",
      ctx: undefined,
      canvas: undefined,
      lastPos: {x: -1, y: -1},
      tempLayer: [],
      scaleX: 1,
      scaleY: 1,
      deleteMode: false,
      decodedDrawing: undefined
    }
  },
  watch: {
		colorValue(val) {
			if(val) {
				this.updateColors(val);
				this.$emit('input', val);
			}
		}
  },
  mounted() {
    this.init();

    this.attachment = annotationUtils.getOrCreateAttachment(this, this.attachmentId, this.contextMenuOptions, 'sketch')

    if(this.attachment.resourceObj.packed) {
      this.drawEncodedDrawing(this.attachment.resourceObj.packed);
    } else {
      this.decodedDrawing = {
        "document": "joumahouniehiervannie",
        "type": "sketch",
        "page": this.contextMenuOptions.section,
        "selector": this.contextMenuOptions.selector,
        "width": 300,
        "height": 300,
        "drawing": []
      }

      this.scaleX = 1;
      this.scaleY = 1;
    }

    var t = this;
    document.addEventListener("keydown", function(e) {
    if (e.keyCode === 27) {
      t.closeFreehandModal();
    }
    });
  },
  methods: {
    closeFreehandModal: function() {
      this.$emit("freehandModalClosed", false);
    },
    upsertFreehand: function() {
      const messagePackData = encode(JSON.parse(JSON.stringify(this.decodedDrawing)));
      const packed = utils.uint8ToBase64(messagePackData);

      const resource = this.attachment.resourceObj;
      resource.packed = packed;

      annotationUtils.upsertAnnotation(this, this.attachmentId, this.attachment, resource);
      this.closeFreehandModal();
    },
    deleteFreehand: function() {
      annotationUtils.deleteAnnotation(this, this.attachment);
      this.closeFreehandModal();
    },
    init: function() {
      this.canvas = document.getElementById("freehandCanvas");
      var container = document.getElementById("freehandContainer");
      this.ctx = this.canvas.getContext("2d");
      this.canvas.addEventListener('mousemove', this.mouseMoveAndDraw);
      this.canvas.addEventListener('mousedown', this.mousePositionUpdated);
      this.canvas.addEventListener('mouseenter', this.mousePositionUpdated);
      this.canvas.addEventListener('mouseup', this.addCurrentLayer);
      this.canvas.addEventListener('mouseleave', this.addCurrentLayer);
    },
    drawEncodedDrawing(packed) {
      var t = this;
      
      var messagePackData = utils.base64ToArrayBuffer(packed); // base64 decode
      t.decodedDrawing = decode(messagePackData);

      t.scaleX = t.$refs.freehandCanvas.clientWidth / t.decodedDrawing.width;
      t.scaleY = t.$refs.freehandCanvas.clientHeight / t.decodedDrawing.height;

      utils.log(this, t.scaleX, t.decodedDrawing.width, t.$refs.freehandCanvas.clientWidth);
      
      if(t.decodedDrawing.drawing) {
        _.each(t.decodedDrawing.drawing, function(layer) {
          t.drawLayer(layer);
        });
      }
    },
    addCurrentLayer() {
      if(this.tempLayer.length === 0) return;

      this.decodedDrawing.drawing.push({
        "colour": this.drawColor.replace("#","#FF"),
        "points": this.tempLayer
      })

      utils.log(this, this.decodedDrawing.drawing)

      this.tempLayer = [];
    },
    drawLayer(layer) {
      var t = this;

      if(!layer.points || layer.points.length == 0) return;

      t.ctx.beginPath();
      t.ctx.lineWidth = 2;
      
      t.ctx.strokeStyle = t.getLayerColour(layer.colour).replace("#FF", "#");
      t.ctx.moveTo(t.scaleX * layer.points[0][0], t.scaleY * layer.points[0][1]);
      
      _.each(layer.points, function(point) {
        t.ctx.lineTo(t.scaleX * point[0], t.scaleY * point[1]);  
      });

      t.ctx.stroke();
    },
    getLayerColour(colour) {
      if (!colour) return "#FF181818";
      if (colour === 0) return "#FF181818";
      if (colour === 1) return "#FFFFFFFF";
      if (colour === 2) return "#FF00FF00";
      if (colour === 3) return "#FF0000FF";
      if (colour === 4) return "#FFFF0000";
      if (colour === 5) return "#FFFFFF00";
      if (colour === 6) return "#FF181818";
      
      return colour;
    },
    mouseMoveAndDraw: function(e) {
      if (e.buttons !== 1) return;
      this.ctx.beginPath();
      this.ctx.lineWidth = 2;
      // this.ctx.lineCap = 'round';
      this.ctx.strokeStyle = this.drawColor;
      this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
      this.mousePositionUpdated(e);
      this.ctx.lineTo(this.lastPos.x, this.lastPos.y);
      this.ctx.stroke();

      this.tempLayer.push([this.lastPos.x * (1.0/this.scaleX), this.lastPos.y * (1.0/this.scaleY)]);
    },
    mousePositionUpdated: function(e) {
      this.lastPos.x = e.offsetX;
      this.lastPos.y = e.offsetY;
    },
    clearCanvas: function() {
      this.decodedDrawing.drawing = [];
      this.ctx.clearRect(0, 0, this.$refs.freehandCanvas.clientWidth, this.$refs.freehandCanvas.clientHeight);
    }
  },
  beforeDestroy() {
    this.canvas.removeEventListener('mousemove', this.mouseMoveAndDraw);
    this.canvas.removeEventListener('mousedown', this.mousePositionUpdated);
    this.canvas.removeEventListener('mouseenter', this.mousePositionUpdated);
    this.canvas.removeEventListener('mouseup', this.addCurrentLayer);
    this.canvas.removeEventListener('mouseleave', this.addCurrentLayer);
  }
}
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.title {
  font-size: 20px;
}

#freehandContainer {
  display: inline-block;
  resize: none;
  width: 367px;
  // border: 1px solid black;
  margin: 15px auto;
  position: relative;

  .freehand-canvas {
    border: 1px solid $border-color;
  }
}

.color-picker-wrapper {
  display: flex;
  margin-left: 30px;

  .color-text {
    display: block;
    // float: left;
    padding-top: 7px;
    padding-right: 7px;
    width: 120px;
    text-align: right;
  }

  .color-picker {
    display: inline-block;
  }
}

.current-color {
    display: inline-block;
    width: 36px;
    height: 36px;
    background-color: #000;
    cursor: pointer;
  }

.clear {
  margin-right: 10px;
}

.modal-content {
  width: 480px !important;
  margin-top: 12%;
}
</style>

